import type { FC } from 'react'

import { Minimize } from '@liveHelper/assets/Minimize'
import {
  actionsSelector,
  callDataSelector,
  uiStateSelector,
  useStore,
  visitorPrivateActionsSelector,
} from '@liveHelper/models/store'
import { Close } from '@oneToOne/shared/assets/Close'
import { actionButton } from '@oneToOne/shared/twind'
import { css } from 'twind/css'

import { ControlsButton } from '@core/components/twind/ControlsButton'
import { useContextTranslation } from '@core/i18n'
import { useTwindContext } from '@core/twind'

/**
 *  Dialing Header when expanded
 */
export const DialingHeader: FC = () => {
  const { t } = useContextTranslation()
  const { tw } = useTwindContext()

  const uiState = useStore(uiStateSelector)
  const { sendUIStateTransitionEvent } = useStore(actionsSelector)
  const { terminateCall, endConversation } = useStore(
    visitorPrivateActionsSelector,
  )
  const callData = useStore(callDataSelector)

  if (uiState === 'dialing_expanded') {
    return (
      <>
        <ControlsButton
          className={tw?.(
            actionButton({
              actionType: 'neutral',
              buttonSize: 'sm',
              shape: 'square',
            }),
            css({ position: 'absolute !important' }),
            'top-1',
            'right-14',
          )}
          aria-label={t(`oneToOne:Minimize Live Helper Dialog`)}
          onClick={(e) => {
            e.stopPropagation()
            sendUIStateTransitionEvent('MINIMIZE')
          }}
          src={<Minimize width="16px" fill="white" label="" aria-hidden />}
        />
        <ControlsButton
          className={tw?.(
            actionButton({
              actionType: 'neutral',
              buttonSize: 'sm',
              shape: 'square',
            }),
            css({ position: 'absolute !important' }),
            'top-1',
            'right-1',
          )}
          aria-label={t(`oneToOne:End call`)}
          onClick={(e) => {
            e.stopPropagation()
            terminateCall?.({
              agentId: callData?.agentId,
              type: 'stopDialing',
            })
            endConversation?.()
          }}
          src={<Close width="16px" fill="white" label="" aria-hidden />}
        />
      </>
    )
  }

  return null
}
